import { ReactElement } from "react"

export type ButtonCardOption = {
  value: string | number
  imageUrl?: string
  title?: string
  description?: string
  icons?: ReactElement[]
}
